import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _KanbanHubBase from '../../../moreCore/UI/Kanban/_KanbanHubBase';
import { KanbanTypes } from "../../../moreCore/UI/Kanban/KanbanTypes";
import { EntityHelpers } from "../../../more/Helpers";
import Edit from '../../../moreCore/UI/Edit/Edit';
import { GenericDialogTypes } from "../../../moreCore/UI/GenericDialog/GenericDialogTypes";
import { DistributionCHannelKanbanDataElement, VtFinance } from "./DistributionChannelKanbanTypes";
import DistributionChannelKanbanView from './DistributionChannelKanbanView';

/**
 * 
 */
/**
 * 
 */

interface EditorData {
    note: string
}
class DistributionChannelKanban extends compose(_KanbanHubBase<any>) {
    //templateString = template; // nur falls nötig ein eigenes laden!


    _onEmbedding() {
    
    }

    private _onClick_Element(data: KanbanTypes.DataElement<any>) {
        //alert(data.sourceItemID);
        EntityHelpers.openEntityView({
            entityClass: "xxx",
            entityId: data.sourceItemID,
            label: data.label,
            contextName: "kanban"
        });
    }
    private _onEdit_Element(data: KanbanTypes.DataElement<Array<VtFinance>>) {
        // hier kommt der Editor her...
        if (!data) return;

        
        let viewer = new DistributionChannelKanbanView();
        viewer.setup(data.assignmentID, data.label);
    }

    private _onKanbanTableSave(data: { changedData: EntityStoreData<VtFinance>, dataElement: DistributionCHannelKanbanDataElement }) {
        if(!data) return
        this.setElementData(data.dataElement, data.changedData);
    }

    private _enableEditBtn(data: KanbanTypes.DataElement<EditorData>): boolean {
        if (!data) return true;
        return !data.wasMoved && !this.UiModder.domClass.contains(data.node, "new");
    }

    private _onSubmitEdit(data: KanbanTypes.DataElement, input: MdsLax<InstanceType<typeof Edit>>, result: GenericDialogTypes.GenericDialogResult) {

        // Editor fertig, Daten ans Kanban schicken
        //
        if (result == GenericDialogTypes.GenericDialogResult.ok) {
            this.setElementData(data, { note: input.getValue() });
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.setup({
            filterpanelAPI: "Webtool_API_DistributionChannelKanban__GetFilterPanel",
            kanbanConfigAPI: "Webtool_API_DistributionChannelKanban__GetKanbanConfig",
            changeSaveAPI: "Webtool_API_DistributionChannelKanban__SaveChanges",
            infoContentAPI: "Webtool_API_DistributionChannelKanban__GetInfoContent",
            //elementDetailsClick: lang.hitch(this, this._onClick_Element),
            elementEditClick: lang.hitch(this, this._onEdit_Element),
            editBtnEnabledCallback: lang.hitch(this, this._enableEditBtn)
        });



    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles("DistributionChannelKanban_MainTitle");
    }

}

export default mdsWidget(DistributionChannelKanban);
